export enum GameType {
  NLH = 'NLH',
  NLH31 = 'NLH31',
  NLHB = 'NLHB',
  NLR = 'NLR',
  NLP = 'NLP',
  NLHS = 'NLHS',
  NLHSB = 'NLHSB',
  NLHDB = 'NLHDB',
  NLHBDB = 'NLHBDB',
  NLHSQ = 'NLHSQ',
  NLHSU = 'NLHSU',

  SNG = 'SNG',
  SPN = 'SPN',

  PLO = 'PLO',
  PLODB = 'PLODB',
  PLOBDB = 'PLOBDB',
  PLOB = 'PLOB',
  PLR = 'PLR',
  PLOSQ = 'PLOSQ',

  NLO = 'NLO',
  NLOB = 'NLOB',
  NLO5 = 'NLO5',

  PLO5 = 'PLO5',
  PLO5B = 'PLO5B',
  PLO5DB = 'PLO5DB',
  PLO5BDB = 'PLO5BDB',
  PLR5 = 'PLR5',
  PLO5SQ = 'PLO5SQ',

  PLO6 = 'PLO6',
  PLO6B = 'PLO6B',
  PLO6DB = 'PLO6DB',
  PLO6BDB = 'PLO6BDB',
  PLO6SQ = 'PLO6SQ',

  MTT = 'MTT',
  MTTPLO = 'MTTPLO',
  MTTPLO5 = 'MTTPLO5',

  MIX = 'MIX',
}
